// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"537":"545744ca","753":"3f550f9a","787":"1e3c3a09"}[chunkId] + ".chunk.js";
};